<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="'/private/settings'" translate>Settings</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Download my data</li>
  </ol>
</nav>

<div class="card mx-auto" style="max-width: 560px;">
  <div class="card-body">
    <h5 class="card-title" translate>Download my data</h5>
    <p class="text-muted" style="font-size: 13px;" translate>
      Get a copy of the personal data Paylink holds about you (PDPL Article 4). The download link is valid for 24 hours and works once.
    </p>

    <div class="alert alert-danger" *ngIf="error" translate>{{error}}</div>
    <div class="alert alert-info" *ngIf="info" translate>{{info}}</div>

    <!-- Step 1: re-enter password -->
    <div *ngIf="step === 'none'">
      <label for="dmd-password" translate>Account password</label>
      <input id="dmd-password" type="password" class="form-control mb-3"
             [(ngModel)]="password" autocomplete="current-password">
      <button class="btn btn-primary w-100" (click)="request()" [disabled]="submitting" translate>
        Request my data copy
      </button>
    </div>

    <!-- Step 2: OTP + download -->
    <div *ngIf="step === 'awaiting-otp'">
      <label for="dmd-otp" translate>Verification code</label>
      <input id="dmd-otp" type="text" class="form-control mb-3" maxlength="6"
             inputmode="numeric" autocomplete="one-time-code" [(ngModel)]="otp">
      <button class="btn btn-primary w-100 mb-2" (click)="download()" [disabled]="submitting" translate>
        Verify and download
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="resend()" [disabled]="submitting" translate>
        Resend code
      </button>
    </div>

    <!-- Step 3: done -->
    <div *ngIf="step === 'done'">
      <div class="alert alert-success" translate>
        Your data copy was downloaded. The link is now used and the file was deleted from our servers.
      </div>
    </div>
  </div>
</div>
